import { connect } from "react-redux";
// API
import api from "api";
// ActionCreator
import { openErrorDialog } from "redux/modules/errorDialog";
import { init, changeForm, setErrors } from "redux/modules/login";
import { setLoginInfo } from "redux/modules/header";

// Component
import Login from "components/Login";
// Utils
import { pathRole } from "utils/formatter";
import history from "utils/history";
import storage from "utils/storage";

const afterLoginPath = () => {
  switch (pathRole()) {
    case "admin":
      return "/customer_list";
    case "customer_admin":
      return "/survey_list";
    case "anser":
      return "/start_question";
    default:
      console.error("no case");
      return null;
  }
};

const mapStateToProps = state => ({ ...state });

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAlive: () => {
    api.get("alive").catch(error => {
      dispatch(openErrorDialog(error));
    });
  },
  handleLogin: params => {
    dispatch(setErrors([]));

    api
      .post("login", params)
      .then(res => {
        if (res.errors) {
          dispatch(setErrors(res.errors));
        } else {
          storage.setToken(res.token);
          history.push(afterLoginPath(), ownProps);
          dispatch(init());
          dispatch(setLoginInfo(res.loginInfo));
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeForm: (key, value) => dispatch(changeForm(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/LoginContainer.js